import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLockEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.19 4.298c-.36.582-.49 1.46-.49 2.602a.7.7 0 1 1-1.4 0c0-1.176.12-2.399.698-3.337C7.623 2.55 8.692 2 10.25 2s2.627.55 3.252 1.563c.579.938.698 2.161.698 3.337a.7.7 0 1 1-1.4 0c0-1.143-.13-2.02-.49-2.602-.312-.507-.868-.898-2.06-.898s-1.748.39-2.06.898M3.25 11.5A3.5 3.5 0 0 1 6.75 8h6.5a3.5 3.5 0 0 1 3.5 3.5v2.75a3.5 3.5 0 0 1-3.5 3.5h-6.5a3.5 3.5 0 0 1-3.5-3.5zm3.5-2a2 2 0 0 0-2 2v2.75a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2V11.5a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLockEmpty;
